module.exports = __webpack_public_path__ + "img/b-icon_close_x.05db187d.svg";